import HeroCarousel from './HeroCarousel';
import HowItWorks from './HowItWorks';
import Flavors from './Flavors';
import Gallery from './Gallery';
import Occasions from './Occasions';
import Reviews from './Reviews';
import OrderSection from './OrderSection';
import Faq from './Faq';
import About from './About';
import NewsletterSection from './NewsletterSection';

export default function LandingPage() {
  return (
    <div className="bg-cream min-h-screen">
      <HeroCarousel />
      <HowItWorks />
      <Flavors />
      <Gallery />
      <Occasions />
      <Reviews />
      <OrderSection />
      <Faq />
      <About />
      <NewsletterSection />
    </div>
  );
}
